/**
 * Created by razial on 11.03.2025.
 */

const Homefix = function () {
    cleverapps.EventEmitter.call(this);

    this.location = cleverapps.meta.getSelectedLocation();

    this.slot = this.location.slot;

    Homefix.currentHomefix = this;

    cleverapps.config.saveUnitsEnabled = false;

    const configData = bundles[this.location.locationConfig.locationBundleId].jsons.data_json.getJson();

    this.config = configData;

    this.furniture = configData.items.map(function (data, id) {
        return new Furniture(this, data, id);
    }, this);

    this.furnitureId = this.slot.load("furniture") || 0;

    const mapData = bundles[this.location.locationConfig.locationBundleId].jsons.map_json.getJson();

    this.map = new Map2d(this.slot, mapData.map, {
        tiles: mapData.tiles,
        units: mapData.units,
        visibleBox: mapData.visibleBox,
        regions: mapData.regions,
        decorators: mapData.decorators,
        terrains: mapData.terrains,
        field: mapData.field,
        background: mapData.background,
        families: this.location.families
    });

    this.map.onUnitAvailableListener = function (unit) {
        if (cleverapps.unitsLibrary.openUnit(unit)) {
            this.map.fogs.wantsCalcFogStates = true;
        }
    }.bind(this);

    if (!cleverapps.config.editorMode) {
        this.map.loadUnits();
        this.map.loadFogs();

        this.map.fogs.initStage();

        cleverapps.config.saveUnitsEnabled = true;

        if (this.map.fogs.blocks.fence_hall) {
            this.map.fogs.blocks.fence_hall.unlock();
        }

        if (this.map.fogs.blocks.outside_fog) {
            this.map.fogs.blocks.outside_fog.unlock();
        }
    } else {
        Map2d.InsertDefaults(this.map, this.map.field);
    }

    // tmp fix after https://gyazo.com/0e517a9055f9a0098380588994b516c0
    const current = this.getCurrentFurniture();
    if (current && current.isComplete()) {
        this.incFurnitureId();
    }

    this.migrateUnits();

    this.map.counter.registerStage(1, this.map.playCinematics.bind(this.map));
    this.map.counter.registerStage(2, this.map.fogs.calcFogStatesStage.bind(this.map.fogs));
    this.map.counter.registerStage(3, this.getTaskToNewFurniture.bind(this));
    this.map.counter.registerStage(4, this.moveNextLocationStage.bind(this));

    if (!cleverapps.config.adminMode && !cleverapps.config.editorMode) {
        this.updateAvailableUnits();
    }
};

Homefix.prototype = Object.create(cleverapps.EventEmitter.prototype);
Homefix.prototype.constructor = Homefix;

Homefix.prototype.stop = function () {
    Map2d.currentMap.stop();
    Map2d.currentMap = undefined;
};

Homefix.prototype.migrateUnits = function () {
    const furniture = this.getFurnitureByName("Garbage_1");

    if (!furniture) {
        return;
    }

    if (furniture.unit && furniture.unit.stage === 0 && this.getCurrentFurnitureId() > 0) {
        furniture.unit.remove();
        delete furniture.unit;
    }

    if (!furniture.unit) {
        Homefix.handleNoUnit(furniture);
    }
};

Homefix.prototype.getInitialScroll = function () {
    return HomefixIntroAnimation.TAXI_POSITIONS[0];
};

Homefix.prototype.updateAvailableUnits = function () {
    this.map.listAvailableUnits().forEach((unit) => {
        const climbableAction = Map2dDecorators.getClimbableAction(unit, true);
        if (climbableAction) {
            climbableAction();
        }
    });
};

Homefix.prototype.getFurniture = function () {
    return this.furniture;
};

Homefix.prototype.getCurrentFurnitureId = function () {
    return this.furnitureId;
};

Homefix.prototype.incFurnitureId = function () {
    this.furnitureId++;
    this.slot.save("furniture", this.furnitureId);

    const current = this.getCurrentFurniture();
    if (current) {
        current.setFresh(true);
    }
};

Homefix.prototype.getFurnitureById = function (id) {
    const furniture = this.getFurniture();

    for (const i in furniture) {
        if (furniture[i].id === id) {
            return furniture[i];
        }
    }
    return undefined;
};

Homefix.prototype.getFurnitureByName = function (name) {
    const furniture = this.getFurniture();

    for (const i in furniture) {
        if (furniture[i].name === name) {
            return furniture[i];
        }
    }
    return undefined;
};

Homefix.prototype.getCurrentFurniture = function () {
    return this.getFurnitureById(this.getCurrentFurnitureId());
};

Homefix.prototype.canBeUpgraded = function () {
    const currentFurniture = this.getCurrentFurniture();
    return currentFurniture && currentFurniture.canBeUpgraded();
};

Homefix.prototype.moveNext = function (furniture, f) {
    const cost = furniture.getInfo().cost;

    this.location.changeStars(-cost);
    furniture.nextStage();

    if (furniture.isComplete()) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.METHA_ITEM}_${cleverapps.meta.selectedLocationId()}_${furniture.id}`);
    }

    this.changeStage(furniture, f);
};

Homefix.prototype.createDialogue = function (dialogueName) {
    const dialogue = this.config.dialogues[dialogueName];
    if (!dialogue) {
        return undefined;
    }

    return new Dialogue(dialogue, {
        autoClose: true,
        showUp: true
    });
};

Homefix.prototype.getTaskToNewFurniture = function () {
    if (!cleverapps.config.saveUnitsEnabled) {
        return;
    }

    if (cleverapps.focusManager.isFocused()) {
        return;
    }

    const current = this.getCurrentFurniture();
    if (!current || !current.isFresh()) {
        return;
    }

    if (!current.unit) {
        Homefix.handleNoUnit(current);
    }

    current.setFresh(false);

    cleverapps.focusManager.display({
        focus: "homefixNewTask",
        action: function (f) {
            this.newTask(f);
        }.bind(this)
    });
};

Homefix.prototype.moveNextLocationStage = function () {
    if (!this.location.isCompleted() || this.location.locationId !== cleverapps.meta.selectedLocationId()) {
        return;
    }

    const nextLocationId = cleverapps.meta.selectedLocationId() + 1;

    if (cleverapps.meta.getLocationMeta(nextLocationId).isUnknown()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "homeMoveNextLocation",
        actions: [
            function (f) {
                cleverapps.meta.startLocation(nextLocationId);

                f();
            },
            function (f) {
                new TravelMapWindow({ animateNext: true });
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            function (f) {
                cleverapps.meta.gotoMainLocation(f);
            }
        ]
    });
};

Homefix.prototype.changeStage = function (furniture, f) {
    let actions = [
        function (f) {
            this.showUnit(furniture.unit, f);
        }.bind(this),

        function (f) {
            this.moveNextUnitStage(furniture.unit, f);
        }.bind(this),

        function (f) {
            this.incFurnitureId();
            f();
        }.bind(this),

        function (f) {
            if (this.location.isCompleted()) {
                const dialogue = this.createDialogue("Final");
                dialogue.on("afterClose", f);
                new DialogueView(dialogue);
            } else {
                f();
            }
        }.bind(this)
    ];

    if (!furniture.isComplete()) {
        actions = actions.concat([
            function (f) {
                this.newTask(f);
            }.bind(this)
        ]);
    } else {
        actions = actions.concat([
            function (f) {
                this.unShowUnit();
                if (this.location.isCompleted()) {
                    new AllDoneWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                } else {
                    f();
                }
            }.bind(this)
        ]);
    }

    cleverapps.focusManager.compound(f, actions);
};

Homefix.prototype.zoomInToUnit = function (unit, silent, callback) {
    const sceneHeight = cleverapps.resolution.getSceneSize().height - cleverapps.resolution.getSafePadding().bottom;
    let zoom = 1.7;

    if (unit.findComponent(Invisible)) {
        zoom = 0.8;
    }

    Map2dScroller.currentScroller.zoomIn(unit, {
        zoom,
        padding: {
            top: 200 * zoom * resolutionScale,
            bottom: Homefix.needHighlight(unit) ? sceneHeight / 8 : 0,
            right: 60 * resolutionScale,
            left: 60 * resolutionScale
        },
        centerOffset: {
            x: 0,
            y: Homefix.needHighlight(unit) ? sceneHeight / 8 : 0
        },
        duration: silent && 0,
        callback
    });
};

Homefix.prototype.showUnit = function (unit, callback, silent) {
    if (!unit) {
        callback();
        return;
    }

    this.shownUnit = unit;
    this.shownUnit.hideAdditionalViews();

    new ActionPlayer([
        function (f) {
            this.zoomInToUnit(unit, silent, f);
        }.bind(this),

        function (f) {
            if (Homefix.needHighlight(unit)) {
                this.map.highlightUnit(unit, f, { spotlight: true, ground: false });
            } else {
                f();
            }
        }.bind(this)
    ]).play(callback);
};

Homefix.prototype.moveNextUnitStage = function (unit, f) {
    if (!unit) {
        f();
        return;
    }

    const throwaway = unit.findComponent(Throwaway);

    if (throwaway) {
        delete this.shownUnit;
        throwaway.animateDestroy(f);
        return;
    }

    const fixable = unit.findComponent(Fixable);

    if (fixable) {
        fixable.updateStage(f);
    }
};

Homefix.prototype.newTask = function (f) {
    const furniture = this.getCurrentFurniture();

    this.trigger("newTask", furniture);

    cleverapps.focusManager.compound(f, [
        function (f) {
            this.showStageDialogue(furniture, f);
        }.bind(this),

        function (f) {
            this.trigger("animateNewTask", furniture, f);
        }.bind(this)
    ]);
};

Homefix.prototype.showStageDialogue = function (furniture, f) {
    cleverapps.focusManager.compound(f, [
        function (f) {
            furniture.updateActiveState();
            this.showUnit(furniture.unit, f);
        }.bind(this),

        function (f) {
            this.crateDialogue(furniture, f);
        }.bind(this),

        function (f) {
            this.unShowUnit();
            cleverapps.timeouts.setTimeout(f, 10);
        }.bind(this)
    ]);
};

Homefix.prototype.crateDialogue = function (furniture, f) {
    const furnitureInfo = furniture.getInfo();

    if (!furnitureInfo) {
        cleverapps.throwAsync("no furniture info");
        f();
        return;
    }

    const dialogue = this.createDialogue(furnitureInfo.dialogue);
    if (!dialogue) {
        f();
        return;
    }

    const regionControl = furniture.unit.findComponent(RegionControl);
    if (regionControl) {
        dialogue.on("showUp", () => {
            regionControl.animateHover();
            dialogue.on("beforeClose", regionControl.stopAnimateHover.bind(regionControl));
        });
    }

    dialogue.on("afterClose", f);

    new DialogueView(dialogue);
};

Homefix.prototype.unShowUnit = function (withZoomOut) {
    if (this.shownUnit) {
        this.shownUnit.showAdditionalViews();
        delete this.shownUnit;
    }

    this.map.unhighlightUnit();

    if (withZoomOut) {
        Map2dScroller.currentScroller.zoomOut();
    } else {
        Map2dScroller.currentScroller.cancelZoomOut();
    }
};

Homefix.prototype.showUp = function (f) {
    cleverapps.focusManager.compound(f, [
        function (f) {
            cleverapps.timeouts.setTimeout(f, 500);
        },

        function (f) {
            cleverapps.restoreProgress.update();
            f();
        },

        function (f) {
            const furniture = this.getCurrentFurniture();
            if (furniture && furniture.id === 0) {
                if (this.canBeUpgraded()) {
                    this.moveNext(furniture, f);
                } else if (!this.forcedAlready) {
                    this.forcedAlready = true;

                    cleverapps.focusManager.compound(f, [

                        function (f) {
                            this.showStageDialogue(furniture, f);
                        }.bind(this),

                        function (f) {
                            Level.WantsToPlay(f, {
                                interstitial: false
                            });
                        }
                    ]);
                } else {
                    f();
                }
            } else {
                f();
            }
        }.bind(this)
    ]);
};

Homefix.handleNoUnit = function (furniture) {
    const code = Families.FurnitureByName[furniture.name].code;
    const fakeUnit = Map2d.currentMap.fogs.findFakeUnit({
        code,
        type: "furniture"
    });

    if (fakeUnit) {
        if (fakeUnit.code === "garbage1") {
            fakeUnit.stage = 1;
        }

        const newUnit = new Unit(fakeUnit);
        let pos = { x: fakeUnit.x, y: fakeUnit.y };

        if (!newUnit.canMoveTo(pos.x, pos.y)) {
            pos = Map2d.currentMap.findEmptySlot(pos.x, pos.y, newUnit);
        }

        newUnit.setPosition(pos.x, pos.y);
        Map2d.currentMap.onAddUnit(pos.x, pos.y, newUnit);
        Map2d.currentMap.add(Map2d.LAYER_UNITS, pos.x, pos.y, newUnit);
        Map2d.currentMap.onUnitAvailable(newUnit);
    } else {
        cleverapps.throwAsync(`no unit ${Families.FurnitureByName[furniture.name].code} for furniture ready to open`);
    }
};

Homefix.GetFurnitureProgress = function (level, furnitureIndex, currentStage) {
    const data = {
        furnitureId: Homefix.currentHomefix.furniture[furnitureIndex].id,
        stars: cleverapps.meta.getSelectedLocation().stars,
        items: {}
    };

    Homefix.currentHomefix.furniture.forEach((furniture, index) => {
        let choice;
        let stage = 0;
        if (index < furnitureIndex) {
            if (furniture.hasChoices()) {
                choice = furniture.choice || 0;
            }
            stage = furniture.amountStages();
        } else if (index === furnitureIndex) {
            stage = currentStage;
        }

        data.items[furniture.id] = {
            choice,
            stage
        };
    });

    return data;
};

Homefix.needHighlight = function (unit) {
    if (unit.findComponent(Invisible)) {
        return false;
    }

    const multiCell = unit.findComponent(MultiCell);
    if (multiCell) {
        const size = multiCell.getSize();
        if (size.width * size.height > 4) {
            return false;
        }
    }

    return true;
};

if (cleverapps.config.debugMode) {
    Homefix.findDuplicateAndMissingUnits = function () {
        const codes = Map2d.currentMap.fogs.listFakeUnits(() => true).map((unit) => unit.code);

        const seen = {};
        const duplicates = [];

        codes.forEach((code) => {
            if (seen[code]) {
                duplicates.push(code);
            } else {
                seen[code] = true;
            }
        });

        return {
            missing: cleverapps.substract(Families.codes, codes),
            duplicates
        };
    };

    Homefix.getUnitsInRegions = function () {
        const result = {};
        for (const name in Map2d.currentMap.regions) {
            if (name.startsWith("fence_")) {
                const positions = Map2d.currentMap.regions[name].positions;

                const units = positions.reduce((accumulator, pos) => {
                    const unit = Map2d.currentMap.getUnit(pos.x, pos.y);
                    if (unit) {
                        accumulator.push(unit);
                    }
                    return accumulator;
                }, []);

                units.sort((a, b) => {
                    const idA = a.findComponent(HomefixIdComponent).furniture.id;
                    const idB = b.findComponent(HomefixIdComponent).furniture.id;
                    return idA - idB;
                });

                result[name] = units;
            }
        }
        return result;
    };
}
